import React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import useAuth from "../../context";

const ProfileSection = ({ open }) => {
    const navigate = useNavigate();
    const auth = useAuth();
    const name = `${auth.user.first_name} ${auth.user.last_name}`;

    const onGetUserDetails = () => {
        navigate(`/dashboard/user-details`);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                padding: "8px",
                color: "#333",
                "&:hover": { backgroundColor: "#FFC700" },
            }}
            onClick={onGetUserDetails}
        >
            <Avatar
                alt={name}
                src={auth.user.picture}
                sx={{ bgcolor: "black" }}
            />
            {open && (
                <>
                    <Box
                        sx={{
                            marginLeft: "10px",
                            width: "calc(100% - 75px)",
                            mr: "auto",
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                // only 1 line of text with ellipsis
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {name || "Guest"}
                        </Typography>
                        {/* <Typography variant="body2">Welcome back!</Typography> */}
                    </Box>
                    <NavigateNextIcon />
                </>
            )}
        </Box>
    );
};

export default ProfileSection;
